export default "__VITE_ASSET__11e2632e__"